var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calculation-box"},[_c('div',{staticClass:"calculation-box__title"},[_vm._v("優惠券折抵")]),_c('div',{staticClass:"calculation-box__list plus-minus"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }